import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import { GetBillingInfo } from "../../../../store/actions/new/storeAction";
import NoContentFound from "../../../default/not-found/notFound";
import { formatAutoShort, PrismTimeFormatter } from "../../../default/utils/timeFormatter";
const BillingData = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.list-edit-dropdown') &&
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    // store data
    const { billings, isLoading } = useSelector((store) => store.storeData);
    const { data, category } = billings;
    const dispatch = useDispatch();
    useEffect(() => {
        if (!data || data.length === 0) {
            dispatch(GetBillingInfo());
        }
    }, [dispatch, data])

    return (
        <div className="card-container card-list-area">
            <div className="list-table connection-list">
                {!isLoading && data &&
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Title</th>
                                <th>Price</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 && data.map((item, index) => {
                                return (
                                    <tr>
                                        <td>{PrismTimeFormatter(item.date)}</td>
                                        <td>
                                            <div className="list-profile">
                                                <span>{item.billing_title} <span className='table-badge'>{item.renewalIntervalUnit === "months" ? "Monthly" : "Yearly"}</span></span>
                                            </div>
                                        </td>
                                        <td>{item.amount}</td>
                                        <td align='right'>
                                            <button
                                                className="share-button icon-button list-btn dropdown-toggle-btn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleDropdown(index);
                                                }}
                                            >
                                                <i
                                                    className="ri-more-2-fill"
                                                ></i>
                                            </button>
                                            <div className="list-edit-dropdown">
                                                {openDropdown === index && (
                                                    <ul>
                                                        <li><a href='#'>Get Invoice</a></li>
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                }
                {isLoading &&
                    <>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                    </>
                }

                {(!data || data.length === 0) && !isLoading && (
                    <div className="no-packages">
                        <NoContentFound title="Data not found!" />
                    </div>
                )}
            </div>
        </div>

    );
}

export default BillingData;